<div class="project-type-title display-flex align-items-center no-wrap" [class.fs-18]="!!data?.title" mat-dialog-title>
  {{ title }}
</div>

<mat-dialog-content>
  <div class="project-type-modal">
    <div [formGroup]="form" class="display-flex flex-column grid-gap-16">
      <div class="flex-1">
        <app-input
          class="flex-grow-1"
          [matFormCss]="'border-radius-partial-left'"
          [attrLabel]="'Name'"
          [attrPlaceholder]="'Enter name'"
          formControlName="name"
          [labelRequired]="true"
          [showValidationError]="submitted"></app-input>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="display-flex justify-content-space-between w-100">
    <button mat-stroked-button color="primary" type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="save()">
      {{ data?.name ? 'Save' : 'Create' }}
    </button>
  </div>
</mat-dialog-actions>
